import { BaseService } from "./../base";
export class CountryService extends BaseService {
  static get entity() {
    return "country";
  }
  static get name() {
    return "country";
  }

  static async getAll() {
    return this.submit("get", `${this.getApiUrlEntity(this.profile)}${this.entity}/all`, this.name);
  }
}
